import React, { useEffect, useState } from "react";
import { useConsentsState } from "@account/consents-shared-lib";
import { GlButton } from "@adl/component-button";
import { useTranslations } from "@crystal/translator";
import { SCENARIO_TYPES } from "../../types/index.js";
import styles from "../consents.module.scss.js";
import ExplicitConsentCheckBox from "./explicit-consent-checkbox.js";
const ExplicitConsent = ({
  document,
  isChecked,
  onChange,
  scenarioType,
  indentCheckbox,
  isSelectAllEnabled,
  isSelectAllChecked
}) => {
  var _a, _b;
  if (!document) {
    return null;
  }
  const t = useTranslations();
  useEffect(() => {
    if (isSelectAllEnabled) {
      const update = { ...document };
      if (document.configuration.acceptanceRequired) {
        if (isSelectAllChecked) {
          update.configuration.accepted = true;
        } else {
          update.configuration.accepted = false;
        }
      }
      onChange(update);
    }
  }, [isSelectAllChecked]);
  const [checked, setChecked] = useState(!!isChecked);
  const {
    document: { link1, link2, documentTitle, documentText1, documentText2, documentText3, documentName, documentType },
    configuration: { acceptanceRequired, accepted } = {}
  } = document;
  const isPreferencePage = scenarioType === SCENARIO_TYPES.ACCOUNT_OPTIN;
  const showError = ((_b = (_a = useConsentsState()) == null ? void 0 : _a[scenarioType]) == null ? void 0 : _b.showErrors) && acceptanceRequired && !accepted;
  const onChangeHandler = ({ target }) => {
    if (isPreferencePage) {
      setChecked(target.checked);
    } else {
      const update = { ...document };
      update.configuration.accepted = target.checked;
      onChange(update);
    }
  };
  const onSubmitHandler = () => {
    const update = { ...document };
    update.configuration.accepted = true;
    onChange(update);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, documentTitle && /* @__PURE__ */ React.createElement("p", { className: "gl-no-margin-bottom gl-label--bold" }, documentTitle), /* @__PURE__ */ React.createElement(
    ExplicitConsentCheckBox,
    {
      name: documentName,
      consent: {
        label: documentText1,
        id: documentType,
        cta: link1,
        close: link2,
        details: [documentText2, documentText3 || ""]
      },
      isChecked: !!isChecked,
      onChange: onChangeHandler,
      required: !!acceptanceRequired,
      className: `gl-vspace-bpall-small ${indentCheckbox ? styles["checkbox-indent"] : ""}`,
      error: showError
    }
  ), checked && isPreferencePage && /* @__PURE__ */ React.createElement(
    GlButton,
    {
      className: styles["permission-sign-up"],
      "data-auto-id": "permission-sign-up-btn",
      onClick: onSubmitHandler
    },
    t("permission.sign.up.btn")
  ));
};
export {
  ExplicitConsent as default
};
//# sourceMappingURL=explicit-consent.js.map
